/** Lower case, no accents, letters and digits only, single spaces: how triggers and visitor messages are compared. */
export const normalize = (s: string) =>
  s
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, " ")
    .trim();

export interface TopicLike {
  title: string;
  triggers: string[];
  answer: string;
  /** Missing means on. */
  enabled?: boolean;
}

/**
 * Predefined answers that never reach the model. A trigger matches when its words appear, in order and contiguously, in the
 * user's message (accent and case insensitive). The first topic in the list that matches wins; a topic switched off is skipped.
 * Lives here, not in the chat runtime, so the settings app's "Test this topic" runs exactly the code the chat runs.
 */
export function matchTopic<T extends TopicLike>(message: string, topics: readonly T[]): T | null {
  const text = ` ${normalize(message)} `;
  for (const topic of topics) {
    if (topic.enabled === false) continue;
    for (const trigger of topic.triggers) {
      const t = normalize(trigger);
      if (t && text.includes(` ${t} `)) return topic;
    }
  }
  return null;
}
